import { c as _c } from "react/compiler-runtime";
import { TextInput, type TextInputProps } from 'design-system/client';
import { forwardRef } from 'react';
import useFormErrorMessage from '../ActionForm/useFormErrorMessage';
const FormInput = forwardRef<HTMLInputElement, TextInputProps>(function FormInput(t0, ref) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const name = props.name;
  const error = useFormErrorMessage(name ?? "");
  let t1;
  if ($[3] !== className || $[4] !== error || $[5] !== props || $[6] !== ref) {
    t1 = <TextInput {...props} type="text" ref={ref} className={className} error={error} />;
    $[3] = className;
    $[4] = error;
    $[5] = props;
    $[6] = ref;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
});
export default FormInput;